import React, { useEffect, useState } from 'react';
import './Page.less';
import './Indicators.less';
import Page from '../components/_layout/Page';
import BackBtn from '../components/UI/BackBtn';
import TabProjects from '../components/IndicatorsTabs/TabProjects';
import TabBudget from '../components/IndicatorsTabs/TabBudget';
import { Tabs, Tab } from '../components/Tabs';
import Progress from '../components/IndicatorsTabs/Progress';
import TabProjectRegistry from '../components/IndicatorsTabs/TabProjectRegistry';

const ProgressData = [
  {
    isPassed: true,
    title: '12 августа 2022',
    text: 'Подписание скорректированной системы МИНОБРНАУКИ. Формирование дополнительных соглашений.',
  },
  {
    isPassed: true,
    title: '24 августа 2022',
    text: 'Интеграция образовательной, научной и инновационной деятельности. Вовлечение компетенций и ресурсов партнеров УрФУ в базовые процессы, в т.ч. образование и работу с молодежью.',
  },
  {
    isCurrent: true,
    title: '24 августа 2022',
    text: 'Интеграция образовательной, научной и инновационной деятельности. Вовлечение компетенций и ресурсов партнеров УрФУ в базовые процессы, в т.ч. образование и работу с молодежью.',
  },
  {
    title: '24 августа 2022',
    text: 'Интеграция образовательной, научной и инновационной деятельности. Вовлечение компетенций и ресурсов партнеров УрФУ в базовые процессы, в т.ч. образование и работу с молодежью.',
  },
  {
    title: '24 августа 2022',
    text: 'Интеграция образовательной, научной и инновационной деятельности. Вовлечение компетенций и ресурсов партнеров УрФУ в базовые процессы, в т.ч. образование и работу с молодежью.',
  },
  {
    title: '24 августа 2022',
    text: 'Интеграция образовательной, научной и инновационной деятельности. Вовлечение компетенций и ресурсов партнеров УрФУ в базовые процессы, в т.ч. образование и работу с молодежью.',
  },
  {
    title: '24 августа 2022',
    text: 'Интеграция образовательной, научной и инновационной деятельности. Вовлечение компетенций и ресурсов партнеров УрФУ в базовые процессы, в т.ч. образование и работу с молодежью.',
  },
];

const tabs = [
  {
    label: 'progress',
    tabName: 'Ход исполнения Программы развития',
    content: <Progress />,
  },
  {
    label: 'projectRegistry',
    tabName: 'Реестр проектов Программы развития',
    content: <TabProjectRegistry />,
  },
  {
    label: 'projects',
    tabName: 'Количество проектов и участников',
    content: <TabProjects />,
  },
  {
    label: 'budget',
    tabName: 'Исполнение бюджета по Программе развития 2025-2036 гг.',
    content: <TabBudget />,
  },
];

export default function Indicators() {
  return (
    <div>
      <Page>
        <div style={{ paddingLeft: '29px' }}>
          <BackBtn />
          <div className="page">
            <article>
              <h3 className="left-aligned-no-icon" style={{ color: '#000070' }}>
                Ключевые индикаторы программы
              </h3>
              <Tabs>
                {tabs.map((tab, i) => (
                  <Tab key={i} label={tab.label} tabName={tab.tabName}>
                    {tab.content}
                  </Tab>
                ))}
              </Tabs>
            </article>
          </div>
        </div>
      </Page>
    </div>
  );
}
